import { FC } from 'react'
import { Select } from 'antd'
import { OptionProps, SelectValue } from 'antd/lib/select'
import { EmployeeWithBuFragment } from '../../../types'
import PerText from '../Text'
import { sortEmployeesWithBusByName } from '../../../modules/companySettings/reviewer/util'
import { useAuth } from '../../../context/auth-context'
import { computeFullname } from '../../../shared/nameDisplayPreferencesUtil'
const { Option } = Select

interface EmployeeReviewerSelectProps {
  employeeId?: string
  employeeData: EmployeeWithBuFragment[]
  onChangeEmployee: (employee?: EmployeeWithBuFragment) => void
  disabled?: boolean
  notFoundContentText: string
  placeholderText: string
}

export const EmployeeReviewerSelect: FC<EmployeeReviewerSelectProps> = ({
  employeeId,
  employeeData,
  onChangeEmployee,
  disabled = false,
  notFoundContentText,
  placeholderText,
}) => {
  const onExtendedChange = (value: SelectValue) => {
    const selectedEmployee = employeeData.find((e) => e.id === value)
    onChangeEmployee(selectedEmployee)
  }
  const { user } = useAuth()

  return (
    <Select
      showSearch
      placeholder={placeholderText}
      notFoundContent={notFoundContentText}
      value={employeeId}
      filterOption={(input: string, option: React.ReactElement<OptionProps>) => {
        if (option && option.props && option.props.children) {
          const perTextProp: React.ReactElement<OptionProps> = option.props.children[0]
          return perTextProp && perTextProp.props && perTextProp.props.children
            ? perTextProp.props.children.toString().toLowerCase().includes(input.trim().toLowerCase())
            : false
        }
        return false
      }}
      onChange={(id: SelectValue) => onExtendedChange(id)}
      className="fullWidth"
      disabled={disabled}
    >
      {sortEmployeesWithBusByName(employeeData).map((employee) => (
        <Option key={`employee-${employee.id}`} value={employee.id}>
          <PerText display="inline">{computeFullname(user.nameDisplayPreference, employee.firstName, employee.lastName)}</PerText>
          <PerText appearance="label-small" display="inline" mx="xxs">
            |
          </PerText>
          <PerText appearance="label-small" display="inline">
            {employee.businessUnit.name}
          </PerText>
        </Option>
      ))}
    </Select>
  )
}
